import { ISideBarItem } from './interface/main.interface';
import i18n from './i18n/i18n';

export const AUTHERIZED_KEY = '@authenticated';
export const AUTHERIZED_USER = '@user';
export const AUTHERIZED_TOKEN = '@token';
export const AUTHERIZED_X_TOKEN = '@xtoken';
export const AUTHERIZED_TOKEN_REFRESH_TIME = '@xtoken_time';

export const __DEV__ = '';
export const BASE_URL = 'https://api.uat.classveew.com/v2';
export const MOCK_BASE_URL = ' http://3.28.240.228:4075/api/v2';
//  export const BASE_URL ='http://3.28.183.13:4001/api/v2'
// new 'http://3.28.240.228/v2/profile/student?page=5&pageSize=1
// http://3.28.240.228/api/v2

export enum COMPONENT_SIZE {
  SMALL = 'sm',
  LARGE = 'lg',
}

/*
We have defined set of constants for application response codes.
These constants are used to standardize error responses across the application.
Need to make sure if we are implementing any new codes we need to communicate
with FE team and align with them
*/
export const APP_ERROR_CODE = {
  ORGANIZATION_UNDER_REVIEW: {
    status: 'ORGANIZATION_UNDER_REVIEW',
  },
  FIRST_LOGIN_PASSWORD_CHANGE: {
    name: 'FIRST_LOGIN_PASSWORD_CHANGE_REQUIRED',
  },
};

export enum SCREEN_MODE {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export enum EXAM_STATUS {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
  COMPLETED = 'COMPLETED',
}

export enum ME_TYPES {
  CLASSROOM = 'classroom',
  POST = 'post',
  TIMETABLE = 'timetable',
}
export const STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export enum LOAN_STATUS {
  AVAILBALE = 'Active',
  ONLOAN = 'On Loan',
}

export enum LEND_TYPES {
  LEND_IN = 'Lend-In',
  LEND_OUT = 'Lend-Out',
}

export enum CIRCULATION_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const POST_CONFIG = {
  rowsPerPage: 10,
};

export enum APP_STATUS {
  LOADING = 'LOADING',
  IDLE = 'IDLE',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INITIAL = 'INITIAL',
}

export enum USER_TYPE {
  ADMIN = 'Admin',
  TEACHER = 'Teacher',
  SUPER_ADMIN = 'SuperAdmin',
}

export enum FORM_VALIDATOR_TYPES {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  OBJECT = 'object',
  ARRAY = 'array',
  EMAIL = 'email',
  FILE = 'file',
  BOOLEAN = 'Boolean',
  GOOGLE_LINK = 'google link',
  TIME = 'time',
  PHONE = 'phone', // Added phone type
  PASSWORD = 'password', // Added password type
  EMAIL_OR_CLASSVEEW_ID = 'email or classveew id', // Login identifier: staff email OR student ClassVeew ID
}

export enum APP_FEATURES {
  VIEW_DASHBOARD = 'View Dashboard',
  GRADE_MANAGEMENT = 'Grade Management',
  CLASSROOM_MANAGEMENT = 'Classroom Management',
  TEACHER_MANAGEMENT = 'Teacher Management',
  TEACHER_ASSIGNMENT_MANAGEMENT = 'Teacher Assignment Management',
  SUBJECT_MANAGEMENT = 'Subject Management',
  STUDENT_MANAGEMENT = 'Student Management',
  SYLLABUS_MANAGEMENT = 'Syllabus Management',
  ACADEMIC_YEAR_MANAGEMENT = 'Academic Year Management',
  ACADEMIC_YEAR_DELETE = 'Academic Year Deletion',
  ROLE_MANAGEMENT = 'Role Management',
  USER_MANAGEMENT = 'User Management',
  BOOK_MANAGEMENT = 'Book Management',
  BOOK_CIRCULATION = 'Book Circulation',
  EXAM_MANAGEMENT = 'Exam Management',
  ATTENDANCE_CUTOFF_MANAGEMENT = 'Attendance Cutoff Management',
  MY_INSTITUTE = 'My Institute',
  FEE_TEMPLATE_MANAGEMENT = 'Fee Template Management',
  INVOICE_MANAGEMENT = 'Invoice Management',
  VIEW_SESSION_HISTORY = 'View Session History',
  ATTENDANCE_MARKING = 'Attendance Marking',
  ROSTER_MANAGEMENT = 'Roster Management',
  EVENT_MANAGEMENT = 'Event Management',
  CURRICULUM_MANAGEMENT = 'Curriculum Management',
  USER_ATTENDANCE = 'User Attendance',
  ORGANIZATION_MANAGEMENT = 'Organization Management',
  CLASSVEEW_ORGANIZATION_MANAGEMENT = 'Classveew Organization Management',
  CLASSVEEW_STUDENT_MANAGEMENT = 'Classveew Student Management',
  CLASSVEEW_TEACHER_MANAGEMENT = 'Classveew Teacher Management',
  CLASSVEEW_AWARD_MANAGEMENT = 'Classveew Award Management',
  RE_ENROLLMENT_MANAGEMENT = 'Re-enrollment Management',
  HOMEWORK_MANAGEMENT = 'Homework Management',
  INITIAL_SYSTEM_SETUP = 'Initial System Setup',
  REPORT_MANAGEMENT = 'Report Management',
  FINANCE_REPORT_MANAGEMENT = 'Finance Report Management',
  STUDENT_REPORT_MANAGEMENT = 'Student Report Management',
  TEACHER_REPORT_MANAGEMENT = 'Teacher Report Management',
  REVOKE_PAYMENT = 'Revoke Payment',
  CANCEL_INVOICE = 'Cancel Invoice',
  DELETE_INVOICE = 'Delete Invoice',
  STUDENT_ATTENDANCE_REPORT_MANAGEMENT = 'Student Attendance Report Management',
  CLASSVEEW_POST_MANAGEMENT = 'Classveew Post Management',
  BILLING_MANAGEMENT = 'Billing Management',
  REFUND_INVOICE = 'Refund Invoice',
}

export const APP_ROUTES = {
  FIRST_CHANGE_PASSWORD: '/first-change-password',
  // Multi-organization users pick an organization here after login
  // (temp-token flow — public branch, user is not fully authenticated yet)
  ORGANIZATION_SELECTION: '/organization-selection',
  ROOT: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  STAFF: '/staff',
  FORBIDDEN: '/access-denied',
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '/not-found',
  WILD_CARD: '/*',
  ORG_INVALID_TOKEN: '/invalid-token',
  ORG_ALREADY_CREATED: '/onboarding/completed',

  FORGET_PASSWORD: '/forgetpassword',
  OTP_FORGET_PASSWORD: '/OtpForgetpassword',
  NEW_CREDENTIALS: '/NewCredentials',
  PASSWORD_UPDATED: '/PasswordUpdated',
  CONFIRM_OTP: '/confirmOtp',

  WELCOME_MESSAGE: '/welcomeMessage',
  CONFIRMATION: '/confirmation',
  // Common, role-neutral landing page for authenticated users with no
  // privilege-gated staff screens (Students today, Guardians later).
  HOME: '/home',

  DEMO_SHCEDULE: '/demoSchedule',
  ADMINISTRATION_DETAILS: '/adminstrationDetails',
  ONBOARDING: '/onboarding',
  SCHOOL_DETAILS: '/schoolDetails',

  STUDENT: '/student-management',
  ATTENDANCE: '/attendance',
  RE_ENROLLMENT_MANAGEMENT: '/re-enrollment-management',
  RE_ENROLLMENT_STUDENT_VIEW: '/re-enrollment-management/cycle/:cycleId/view-students',

  // Finance
  INVOICE_MANAGEMENT: '/invoice-management',
  SESSION_REQUIRED: '/session-required',
  SESSION_HISTORY: '/session-history',
  FEE_TEMPLATE: '/template-management',
  BILLING_AND_PLANS: '/billing-and-plans',

  // Staff & users
  TEACHER_MANAGEMENT: '/teacher-management',
  CREATE_TEACHER: '/teacher-management/create',
  EDIT_TEACHER: '/teacher-management/edit',

  ROLE_MANAGEMENT: '/role-management',
  CREATE_ROLE: '/role-management/create',
  EDIT_ROLE: '/role-management/edit',
  VIEW_ROLE: '/role-management/view',

  USER_MANAGEMENT: '/user-management',
  CREATE_USER: '/user-management/create',
  EDIT_USER: '/user-management/edit',

  GUARDIAN_MANAGEMENT: '/guardian-management',

  ORGANIZATION_ADMIN_MANAGEMENT: '/organization-admin-management',

  // Admin
  ADMIN_ORGANIZATIONS: '/classveew/organizations',
  ADMIN_REQUEST_ORGANIZATIONS: '/classveew/request-organizations',
  ADMIN_ORGANIZATION_CREATE: '/classveew/organizations/create',
  ADMIN_ORGANIZATION_VIEW: '/classveew/organizations/:id/view',
  ADMIN_ORGANIZATION_EDIT: '/classveew/organizations/:id/edit',
  ADMIN_STUDENTS: '/classveew/student-management',
  ADMIN_STUDENT_VIEW: '/classveew/student-management/:id/view',
  ADMIN_STUDENT_EDIT: '/classveew/student-management/:id/edit',
  ADMIN_TEACHERS: '/classveew/teacher-management',
  ADMIN_TEACHER_VIEW: '/classveew/teacher-management/:id/view',
  ADMIN_TEACHER_EDIT: '/classveew/teacher-management/:id/edit',
  ADMIN_AWARDS: '/classveew/awards',
  ADMIN_NEWS_FEED: '/classveew/news-feed',

  // Academic
  TIMETABLE_MANAGEMENT: '/timeTable-management',
  MANAGE_TIMETABLE: '/timeTable-management/manage',

  SYLLABUS_MANAGEMENT: '/syllabus-management',
  CREATE_SYLLABUS: '/syllabus-management/create',
  EDIT_SYLLABUS: '/syllabus-management/edit',

  EXAM_MANAGEMENT: '/exam-management',
  VIEW_EXAM: '/exam-management/view',
  HOMEWORK_MANAGEMENT: '/homework-management',
  CREATE_HOMEWORK: '/homework-management/create',
  EDIT_HOMEWORK: '/homework-management/:homeworkId/edit',
  VIEW_HOMEWORK: '/homework-management/:homeworkId/view',
  HOMEWORK_TASK_GRADING: '/homework-management/:homeworkId/grading/:detailId',

  ASSIGN_CLASSROOMS: '/assign-classrooms',

  // Library
  BOOK_MANAGEMENT: '/book-management',
  BOOK_CIRCULATION: '/book-circulation',

  // MASTER DATA
  OPERATIONAL_TIME_SETTINGS: '/operational-time-settings',
  CURRICULUM_MANAGEMENT: '/curriculum-management',
  ACADEMIC_YEAR_MANAGEMENT: '/academic-year-management',
  GRADE_MANAGEMENT: '/grade-management',
  CLASSROOM_MANAGEMENT: '/classroom-management',
  SUBJECT_MANAGEMENT: '/subject-management',
  SUBJECT_ASSIGN: '/subject-management/assignment',
  MY_INSTITUTE: '/my-institute',

  // Communication
  EVENT_MANAGEMENT: '/event-management',
  CREATE_EVENT: '/event-management/create',
  VIEW_EVENT_CONSENT: '/event-management/consent',

  // Change Password
  CHANGE_PASSWORD: '/change-password',

  // Teacher Attendance
  TEACHER_ATTENDANCE: '/teacher-attendance',

  // ETL Dashboard (Initial System Setup)
  ETL_DASHBOARD: '/etl-dashboard',

  // ETL Quick Setup (Template Selection — CVA-3416)
  ETL_QUICK_SETUP: '/etl-quick-setup',

  // ETL Quick Setup Review/Confirm — CVA-3417
  ETL_QUICK_SETUP_REVIEW: '/etl-quick-setup/review',

  // Reports
  REPORTS: '/reports',
  REPORTS_FINANCE: '/reports/finance',
  REPORTS_STUDENT: '/reports/students',
  REPORTS_TEACHER: '/reports/teachers',
  REPORTS_STUDENT_ATTENDANCE: '/reports/student-attendance',

  // AI Marketing Agent
  CLASSVEEW_AI: '/classveew-ai',
};

/**
 * Routes accessible when organization is restricted due to unpaid invoices
 * Used by SubscriptionGuard and SideMenu for access control
 */
export const RESTRICTED_ALLOWED_ROUTES = [
  APP_ROUTES.BILLING_AND_PLANS,
  APP_ROUTES.CHANGE_PASSWORD,
  APP_ROUTES.FORBIDDEN, // Non-billing users land here when org is restricted
];

// Common UI strings for empty lists and CTAs
export const DROPDOWN_EMPTY_LIST = {
  DEFAULT_MESSAGE: "You don't have any options yet.",
  DEFAULT_CTA: 'Create new',
};

export const SIDE_BAR_ITEMS: ISideBarItem[] = [
  {
    label: 'Dashboard',
    icon: 'DashBoardIcon',
    privileges: [APP_FEATURES.VIEW_DASHBOARD],
    route: APP_ROUTES.DASHBOARD,
    isShown: true,
  },
  {
    label: 'News Feed',
    icon: 'newsFeedIcon',
    route: APP_ROUTES.ADMIN_NEWS_FEED,
    privileges: [APP_FEATURES.CLASSVEEW_POST_MANAGEMENT],
    isShown: true,
  },
  {
    label: 'Organization Management',
    icon: 'classveewOrgMgtIcon',
    route: '',
    privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Approved Organization',
        route: APP_ROUTES.ADMIN_ORGANIZATIONS,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Request Organization',
        route: APP_ROUTES.ADMIN_REQUEST_ORGANIZATIONS,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Organization Management - Create',
        icon: 'classveewOrgMgtIcon',
        route: APP_ROUTES.ADMIN_ORGANIZATION_CREATE,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Organization Management - View',
        icon: 'classveewOrgMgtIcon',
        route: APP_ROUTES.ADMIN_ORGANIZATION_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Organization Management - Edit',
        icon: 'classveewOrgMgtIcon',
        route: APP_ROUTES.ADMIN_ORGANIZATION_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_ORGANIZATION_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Student Management',
    icon: 'studentManagementIcon',
    route: APP_ROUTES.ADMIN_STUDENTS,
    privileges: [APP_FEATURES.CLASSVEEW_STUDENT_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Student Management - View',
        icon: 'studentManagementIcon',
        route: APP_ROUTES.ADMIN_STUDENT_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_STUDENT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Student Management - Edit',
        icon: 'studentManagementIcon',
        route: APP_ROUTES.ADMIN_STUDENT_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_STUDENT_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Teacher Management',
    icon: 'teacherManagementIcon',
    route: APP_ROUTES.ADMIN_TEACHERS,
    privileges: [APP_FEATURES.CLASSVEEW_TEACHER_MANAGEMENT],
    isShown: true,
    children: [
      {
        label: 'Teacher Management - View',
        icon: 'teacherManagementIcon',
        route: APP_ROUTES.ADMIN_TEACHER_VIEW,
        privileges: [APP_FEATURES.CLASSVEEW_TEACHER_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Teacher Management - Edit',
        icon: 'teacherManagementIcon',
        route: APP_ROUTES.ADMIN_TEACHER_EDIT,
        privileges: [APP_FEATURES.CLASSVEEW_TEACHER_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'Award Management',
    icon: 'MasterDataIcon',
    route: APP_ROUTES.ADMIN_AWARDS,
    privileges: [APP_FEATURES.CLASSVEEW_AWARD_MANAGEMENT],
    isShown: true,
  },
  {
    label: 'My Institute Profile',
    icon: 'myInstituteIcon',
    route: APP_ROUTES.MY_INSTITUTE,
    privileges: [APP_FEATURES.ORGANIZATION_MANAGEMENT],
    isShown: true,
  },
  {
    label: 'Students',
    icon: 'ManageIcon',
    route: '',
    children: [
      {
        label: 'Student Management',
        route: APP_ROUTES.STUDENT,
        privileges: [APP_FEATURES.STUDENT_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Student Management - Edit',
            route: `${APP_ROUTES.STUDENT}/:id/edit`,
            privileges: [APP_FEATURES.STUDENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Student Management - View',
            route: `${APP_ROUTES.STUDENT}/:id/view`,
            privileges: [APP_FEATURES.STUDENT_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Attendance Tracking',
        route: APP_ROUTES.ATTENDANCE,
        privileges: [APP_FEATURES.ATTENDANCE_MARKING],
        isShown: true,
      },
      {
        label: 'Re-enrollment Management',
        route: APP_ROUTES.RE_ENROLLMENT_MANAGEMENT,
        privileges: [APP_FEATURES.RE_ENROLLMENT_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_reenrolment',
        children: [
          {
            label: 'Student Re-enrollment - View',
            route: APP_ROUTES.RE_ENROLLMENT_STUDENT_VIEW,
            privileges: [APP_FEATURES.RE_ENROLLMENT_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Finance',
    icon: 'financeIcon', // Replace with actual icon import
    route: '',
    subscriptionFeature: 'fee_management',
    children: [
      {
        label: 'Invoice Management',
        route: APP_ROUTES.INVOICE_MANAGEMENT,
        privileges: [APP_FEATURES.INVOICE_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Cashier Sessions',
        route: APP_ROUTES.SESSION_HISTORY,
        privileges: [APP_FEATURES.VIEW_SESSION_HISTORY],
        isShown: true,
      },
      {
        label: 'Template Management',
        route: APP_ROUTES.FEE_TEMPLATE,
        privileges: [APP_FEATURES.FEE_TEMPLATE_MANAGEMENT],
        isShown: true,
      },
    ],
  },
  {
    label: 'Staff & Users',
    icon: 'staffUsersIcon', // Replace with actual icon import
    route: '',
    children: [
      {
        label: 'Teacher Management',
        route: APP_ROUTES.TEACHER_MANAGEMENT,
        privileges: [APP_FEATURES.TEACHER_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create Teacher',
            route: APP_ROUTES.CREATE_TEACHER,
            privileges: [APP_FEATURES.TEACHER_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Teacher',
            route: `${APP_ROUTES.EDIT_TEACHER}/:id`,
            privileges: [APP_FEATURES.TEACHER_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Teacher Attendance',
        route: APP_ROUTES.TEACHER_ATTENDANCE,
        privileges: [APP_FEATURES.USER_ATTENDANCE],
        isShown: true,
        subscriptionFeature: 'has_teacher_attendance',
        children: [],
      },
      {
        label: 'Role Management',
        route: APP_ROUTES.ROLE_MANAGEMENT,
        privileges: [APP_FEATURES.ROLE_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create Role',
            route: APP_ROUTES.CREATE_ROLE,
            privileges: [APP_FEATURES.ROLE_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Role',
            route: `${APP_ROUTES.EDIT_ROLE}/:id`,
            privileges: [APP_FEATURES.ROLE_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Guardian Management',
        route: APP_ROUTES.GUARDIAN_MANAGEMENT,
        privileges: [APP_FEATURES.USER_MANAGEMENT],
        isShown: true,
        children: [],
      },
      {
        label: 'Admin Management',
        route: APP_ROUTES.ORGANIZATION_ADMIN_MANAGEMENT,
        privileges: [APP_FEATURES.USER_MANAGEMENT],
        isShown: true,
        children: [],
      },
      {
        label: 'User Management',
        route: APP_ROUTES.USER_MANAGEMENT,
        privileges: [APP_FEATURES.USER_MANAGEMENT],
        isShown: true,
        children: [
          {
            label: 'Create User',
            route: APP_ROUTES.CREATE_USER,
            privileges: [APP_FEATURES.USER_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit User',
            route: `${APP_ROUTES.EDIT_USER}/:id`,
            privileges: [APP_FEATURES.USER_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Communication',
    icon: 'communicationIcon',
    route: '',
    children: [
      {
        label: 'Event Management',
        route: APP_ROUTES.EVENT_MANAGEMENT,
        privileges: [APP_FEATURES.EVENT_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'event_creation_level',
        children: [
          {
            label: 'Create Event',
            route: `${APP_ROUTES.CREATE_EVENT}`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Event',
            route: `${APP_ROUTES.EVENT_MANAGEMENT}/:id/${SCREEN_MODE.EDIT}`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'View Event',
            route: `${APP_ROUTES.EVENT_MANAGEMENT}/:id/${SCREEN_MODE.VIEW}`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'View Event Consent Details',
            route: `${APP_ROUTES.VIEW_EVENT_CONSENT}/:id`,
            privileges: [APP_FEATURES.EVENT_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Academic',
    icon: 'academicIcon',
    route: '',
    children: [
      {
        label: 'Timetable Management',
        route: APP_ROUTES.TIMETABLE_MANAGEMENT,
        privileges: [APP_FEATURES.ROSTER_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_timetable',
        children: [
          {
            label: 'Manage Timetable',
            route: `${APP_ROUTES.MANAGE_TIMETABLE}/:id`,
            privileges: [APP_FEATURES.ROSTER_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Exam Management',
        route: APP_ROUTES.EXAM_MANAGEMENT,
        privileges: [APP_FEATURES.EXAM_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'exam_management',
        children: [
          {
            label: 'Exam Details',
            route: `${APP_ROUTES.VIEW_EXAM}/:id`,
            privileges: [APP_FEATURES.EXAM_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Homework Management',
        route: APP_ROUTES.HOMEWORK_MANAGEMENT,
        privileges: [APP_FEATURES.HOMEWORK_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'has_homework_module',
        children: [
          {
            label: 'Create Homework',
            route: APP_ROUTES.CREATE_HOMEWORK,
            privileges: [APP_FEATURES.HOMEWORK_MANAGEMENT],
            isShown: false,
          },
        ],
      },
      {
        label: 'Classroom Assignment',
        route: APP_ROUTES.ASSIGN_CLASSROOMS,
        privileges: [APP_FEATURES.TEACHER_ASSIGNMENT_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Subject Assignment',
        route: APP_ROUTES.SUBJECT_ASSIGN,
        privileges: [APP_FEATURES.SUBJECT_MANAGEMENT],
        isShown: true,
      },
    ],
  },
  {
    label: 'Library',
    icon: 'libraryIcon', // Replace with actual icon import
    route: '',
    subscriptionFeature: 'library_management',
    children: [
      {
        label: 'Book Management',
        route: APP_ROUTES.BOOK_MANAGEMENT,
        privileges: [APP_FEATURES.BOOK_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Book Circulation',
        route: APP_ROUTES.BOOK_CIRCULATION,
        privileges: [APP_FEATURES.BOOK_CIRCULATION],
        isShown: true,
      },
    ],
  },
  {
    label: 'Master Data',
    icon: 'MasterDataIcon',
    route: '',
    children: [
      {
        label: 'Curriculum Management',
        route: APP_ROUTES.CURRICULUM_MANAGEMENT,
        privileges: [APP_FEATURES.CURRICULUM_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_academics',
      },
      {
        label: 'Academic Year Management',
        route: APP_ROUTES.ACADEMIC_YEAR_MANAGEMENT,
        privileges: [APP_FEATURES.ACADEMIC_YEAR_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'academic_year',
      },
      {
        label: 'Operational Time Settings',
        route: APP_ROUTES.OPERATIONAL_TIME_SETTINGS,
        privileges: [APP_FEATURES.ATTENDANCE_CUTOFF_MANAGEMENT],
        isShown: true,
      },

      {
        label: 'Grade Management',
        route: APP_ROUTES.GRADE_MANAGEMENT,
        privileges: [APP_FEATURES.GRADE_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_academics',
      },
      {
        label: 'Classroom Management',
        route: APP_ROUTES.CLASSROOM_MANAGEMENT,
        privileges: [APP_FEATURES.CLASSROOM_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Subject Management',
        route: APP_ROUTES.SUBJECT_MANAGEMENT,
        privileges: [APP_FEATURES.SUBJECT_MANAGEMENT],
        isShown: true,
      },
      {
        label: 'Syllabus Management',
        route: APP_ROUTES.SYLLABUS_MANAGEMENT,
        privileges: [APP_FEATURES.SYLLABUS_MANAGEMENT],
        isShown: true,
        subscriptionFeature: 'can_manage_syllabus',
        children: [
          {
            label: 'Create Syllabus',
            route: `${APP_ROUTES.CREATE_SYLLABUS}`,
            privileges: [APP_FEATURES.SYLLABUS_MANAGEMENT],
            isShown: false,
          },
          {
            label: 'Edit Syllabus',
            route: `${APP_ROUTES.EDIT_SYLLABUS}/:id`,
            privileges: [APP_FEATURES.SYLLABUS_MANAGEMENT],
            isShown: false,
          },
        ],
      },
    ],
  },
  {
    label: 'Billing & Plans',
    icon: 'BillingIcon',
    route: APP_ROUTES.BILLING_AND_PLANS,
    privileges: [APP_FEATURES.BILLING_MANAGEMENT],
    isShown: true,
  },
  {
    label: 'Reports',
    icon: 'reportIcon',
    route: APP_ROUTES.REPORTS,
    privileges: [APP_FEATURES.REPORT_MANAGEMENT],
    isShown: true,
    subscriptionFeature: 'analytics_dashboard',
    children: [
      {
        label: 'Finance Report',
        route: APP_ROUTES.REPORTS_FINANCE,
        privileges: [APP_FEATURES.FINANCE_REPORT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Student Report',
        route: APP_ROUTES.REPORTS_STUDENT,
        privileges: [APP_FEATURES.STUDENT_REPORT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Teacher Report',
        route: APP_ROUTES.REPORTS_TEACHER,
        privileges: [APP_FEATURES.TEACHER_REPORT_MANAGEMENT],
        isShown: false,
      },
      {
        label: 'Student Attendance Report',
        route: APP_ROUTES.REPORTS_STUDENT_ATTENDANCE,
        privileges: [APP_FEATURES.STUDENT_ATTENDANCE_REPORT_MANAGEMENT],
        isShown: false,
      },
    ],
  },
  {
    label: 'ETL Dashboard',
    icon: 'etlSetupIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Quick Setup: Select Curriculum',
    route: APP_ROUTES.ETL_QUICK_SETUP,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: false,
  },
  {
    label: 'Quick Setup: Review Summary',
    route: APP_ROUTES.ETL_QUICK_SETUP_REVIEW,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: false,
  },
  {
    label: 'Classveew AI',
    icon: 'pi pi-sparkles',
    route: APP_ROUTES.CLASSVEEW_AI,
    isShown: true,
  },

  {
    label: 'Change Password',
    icon: 'changePasswordIcon',
    route: APP_ROUTES.CHANGE_PASSWORD,
    isShown: false,
  },
];

/**
 * Sidebar items displayed during Initial System Setup
 * SuperAdmin users with only INITIAL_SYSTEM_SETUP privilege see these items
 * All items route to ETL_DASHBOARD where initial configuration is performed
 */
export const INITIAL_SYSTEM_SETUP_SIDEBAR_ITEMS: ISideBarItem[] = [
  {
    label: 'Dashboard',
    icon: 'DashBoardIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'My Institute',
    icon: 'myInstituteIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Students',
    icon: 'ManageIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Finance',
    icon: 'financeIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Staff & Users',
    icon: 'staffUsersIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Communication',
    icon: 'communicationIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Academic',
    icon: 'academicIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Library',
    icon: 'libraryIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
  {
    label: 'Master Data',
    icon: 'MasterDataIcon',
    route: APP_ROUTES.ETL_DASHBOARD,
    privileges: [APP_FEATURES.INITIAL_SYSTEM_SETUP],
    isShown: true,
  },
];

export const SIDE_MENU_BOTTOM_ITEMS: ISideBarItem[] = [
  {
    label: 'Change Password',
    icon: 'changePasswordIcon',
    route: APP_ROUTES.CHANGE_PASSWORD,
    isShown: true,
  },
];
